import axiosInstance from "../Interceptors/ResponseInterceptor";

export const getActivityHistoryByID = async (activityId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.get(
        `/api/activity-remarks/${activityId}`
      );
      resolve(response.data);
    } catch (error) {
      console.error("Error in createPassword:", error);
      reject(error);
    }
  });
};

export async function getStagesAndSubActivities(partnerId) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.get(
        `/api/activity-metadata/activity-stages/${partnerId}`
      );
      resolve(response.data);
    } catch (error) {
      console.error("Error in fetching Activity and Stages ", error);
    }
  });
}
